/** Design tokens for Insights 2.0 shell — matches insights-shell-mock.html (white surfaces). */

export const shellTokens = {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    monoFamily: '"SFMono-Regular", "Roboto Mono", Consolas, monospace',
    radius: 14,
    innerRadius: 10,
    bg: '#ffffff',
    surface: '#ffffff',
    border: 'rgba(15, 23, 42, 0.09)',
    text: '#0f172a',
    muted: '#64748b',
    primary: '#2563eb',
    success: '#16a34a',
    warning: '#d97706',
    error: '#dc2626',
    sidebarWidth: 220,
    topbarHeight: 52,
    bottomNavHeight: 62,
};

export const shellSx = {
    app: {
        display: 'flex',
        minHeight: '100vh',
        bgcolor: shellTokens.bg,
        color: shellTokens.text,
        fontFamily: shellTokens.fontFamily,
    },
    sidebar: {
        width: shellTokens.sidebarWidth,
        flexShrink: 0,
        bgcolor: shellTokens.surface,
        borderRight: `1px solid ${shellTokens.border}`,
        display: { xs: 'none', md: 'flex' },
        flexDirection: 'column',
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: 50,
    },
    mainWrap: {
        flex: 1,
        ml: { xs: 0, md: `${shellTokens.sidebarWidth}px` },
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
    },
    topbar: {
        height: shellTokens.topbarHeight,
        bgcolor: shellTokens.surface,
        borderBottom: `1px solid ${shellTokens.border}`,
        display: 'flex',
        alignItems: 'center',
        px: 2.5,
        gap: 1.5,
        position: 'sticky',
        top: 0,
        zIndex: 40,
    },
    content: {
        flex: 1,
        p: { xs: 2, md: '16px 20px' },
        pb: { xs: `calc(${shellTokens.bottomNavHeight}px + 16px)`, md: 2.5 },
        maxWidth: 1600,
    },
    navGroupLabel: {
        fontSize: '0.6rem',
        fontWeight: 700,
        letterSpacing: '0.07em',
        textTransform: 'uppercase',
        color: shellTokens.muted,
        px: 2.25,
        pt: 1.75,
        pb: 0.75,
    },
    navItem: (active) => ({
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        width: '100%',
        border: 'none',
        bgcolor: active ? 'rgba(37, 99, 235, 0.08)' : 'transparent',
        py: 1.25,
        px: 2.25,
        fontSize: '0.84rem',
        fontWeight: 600,
        color: active ? shellTokens.primary : shellTokens.muted,
        cursor: 'pointer',
        textAlign: 'left',
        borderLeft: '3px solid',
        borderLeftColor: active ? shellTokens.primary : 'transparent',
        '&:hover': {
            bgcolor: 'rgba(37, 99, 235, 0.05)',
            color: shellTokens.text,
        },
    }),
    bottomNav: {
        display: { xs: 'block', md: 'none' },
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: shellTokens.bottomNavHeight,
        bgcolor: shellTokens.surface,
        borderTop: `1px solid ${shellTokens.border}`,
        zIndex: 60,
    },
    panel: {
        bgcolor: shellTokens.surface,
        border: `1px solid ${shellTokens.border}`,
        borderRadius: `${shellTokens.radius}px`,
        overflow: 'hidden',
    },
    placeholder: {
        p: 4,
        textAlign: 'center',
        color: shellTokens.muted,
        fontSize: '0.84rem',
        border: `1px dashed ${shellTokens.border}`,
        borderRadius: `${shellTokens.innerRadius}px`,
        bgcolor: shellTokens.surface,
    },
};
